/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";

export default function Footer() {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={"center"}
      justifyContent="center"
      px="30px"
      pb="20px"
    >
      <Text color="gray.500" textAlign={"center"} mb={{ base: "20px", xl: "0px" }}>
        &copy; {1900 + new Date().getYear()}{" "}
        <Text as="span">CogniSigner Team. Pioneering efficient digital signatures with ❤️.</Text>
      </Text>
    </Flex>
  );
}
